import { useEffect, useState } from "react";
import api from "../../../../../../../services/api";
import { IItemHistorico } from "../../../../types";
import { DadosOrientacaoCompleta } from "./types";
import { mapearAnexosOrientacaoCompleta, mapearCamposOrientacaoCompleta } from "./utils";
import { ExpandedContent, Separator } from "./styles";
import BlocoOrientacaoCompleta from "./Blocos/BlocoOrientacaoCompleta";
import BlocoAnexos from "./Blocos/BlocoAnexos";
import LogsVazio from "../../Compartilhado/LogsVazio";

interface ExpandedContentProps {
    item: IItemHistorico;
    onNavigateToFile?: (fileId: number) => void;
}

export default function ExpandedContentOrientacaoCompletaCriada({ item, onNavigateToFile }: ExpandedContentProps) {
    const [dados, setDados] = useState<DadosOrientacaoCompleta | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!item?.id) {
            setLoading(false);
            setDados(null);
            return;
        }

        const carregarDados = async () => {
            setLoading(true);

            try {
                const resposta = await api.get(`log-historico/${item.id}`);

                if (resposta.data.status === "success") {
                    const logs = resposta.data.result || [];
                    const logOrientacao = logs.find((log: any) => log.entidade_nome === "orientacao");

                    const campos = mapearCamposOrientacaoCompleta(logOrientacao?.dados_antes, logOrientacao?.dados_depois);
                    const anexos = mapearAnexosOrientacaoCompleta(logs);

                    setDados({
                        campos,
                        anexos
                    });
                } else {
                    setDados(null);
                }
            } catch (_error) {
                setDados(null);
            } finally {
                setLoading(false);
            }
        };

        carregarDados();
    }, [item.id]);

    if (loading) {
        return (
            <ExpandedContent>
                <div style={{ padding: "20px", textAlign: "center", color: "var(--c64748b)" }}>
                    Carregando dados...
                </div>
            </ExpandedContent>
        );
    }

    if (!dados) {
        return (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    }

    const temDadosValidos = (dados.campos && dados.campos.length > 0) || (dados.anexos && dados.anexos.length > 0);

    if (!temDadosValidos) {
        return (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    }

    return (
        <ExpandedContent>
            <Separator />
            <BlocoOrientacaoCompleta campos={dados.campos} />
            <BlocoAnexos anexos={dados.anexos} onNavigateToFile={onNavigateToFile} />
        </ExpandedContent>
    );
}

